<template>
  <v-dialog
    hide-overlay
    v-model="dialog"
    width="330"
    open-on-focus
    no-click-animation
    persistent
    content-class="sequence-copy-exercises-dialog"
    :origin="`bottom right`"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <v-form ref="form" class="sequence-copy-exercises-form" @submit.prevent="onSubmit">
        <div class="sequence-copy-exercises-form-body">
          <v-toolbar
            flat
            height="76"
          >
            <v-toolbar-title class="sequence-copy-exercises-toolbar-title">Copy and paste activities</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              color="accent"
              icon
              tile
              @click="closeDialog"
            >
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container class="sequence-copy-exercises-card-container">
            <div>
              <h5>Start day</h5>
              <div class="d-flex align-center">
                <bh-number-input
                  label="start"
                  name="start"
                  v-model="startValue"
                  :minNumber="1"
                  :maxNumber="maxDays"
                  :value="1"
                  @input="onInput({name: 'start', value: $event})"
                />
              </div>
            </div>
          </v-container>
          <v-container class="sequence-copy-exercises-card-container">
            <div>
              <h5>Interval between days</h5>
              <div class="d-flex align-center">
                <bh-number-input
                  label="interval"
                  name="interval"
                  v-model="intervalValue"
                  :minNumber="1"
                  :maxNumber="maxDays"
                  :value="1"
                  @input="onInput({name: 'interval', value: $event})"
                />
              </div>
            </div>
          </v-container>
          <v-container class="sequence-copy-exercises-card-container">
            <div>
              <h5>How many repetitions?</h5>
              <div class="d-flex align-center">
                <bh-number-input
                  label="repetitions"
                  name="repetitions"
                  v-model="repetitionsValue"
                  :minNumber="1"
                  :maxNumber="maxDays"
                  :value="1"
                  @input="onInput({name: 'repetitions', value: $event})"
                />
              </div>
            </div>
          </v-container>
          <v-container v-if="isOutOfRange" class="sequence-copy-exercises-card-container">
            <div>
              <p>Cannot create longer than 3 months Routine, later Activities ignored</p>
            </div>
          </v-container>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            color="primary"
            elevation="0"
            type="submit">
            Submit
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import RouterMixin from "@/mixins/router"
import { debounce } from "@/helpers/debounce"
import TenantTextsMixin from '@/mixins/tenantTexts'
import BhNumberInput from '@/components/inputs/BhNumberInput.vue'

const SEQUENCE_DAYS = 100

const emptyForm = {
  items: [],
  start: 1,
  repetitions: 1,
  interval: 1,
}

export default {
  name: 'SequenceExerciseDialog',
  components: {
    BhNumberInput
  },
  mixins: [
    RouterMixin,
    TenantTextsMixin
  ],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    sequenceCopyExercisesData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      tab: null,
      dialog: false,
      copyExercisesData: {
        items: [],
        start: 1,
        repetitions: 1,
        interval: 1,
      },
      startValue: 1,
      repetitionsValue:1,
      intervalValue: 1,
      formIsValidCheck: false,
      maxDays: SEQUENCE_DAYS,
    }
  },
  watch: {
    showDialog: function (val) {
      if (val) {
        this.dialog = true
        this.copyExercisesData.items = this.$props.sequenceCopyExercisesData?.exercises || []
      } else {
        this.dialog = false
        this.clearForm()
      }
    },
    sequenceCopyExercisesData: {
      handler (newVal, oldVal) {
        const exercises = newVal?.exercises || []
        const oldExercises = JSON.stringify(oldVal?.exercises || [])
        const newExercises = JSON.stringify(exercises)
        if (oldExercises !== newExercises) {
          this.copyExercisesData.items = [...exercises]
        }

        this.formIsValid()

        if (!exercises?.length) {
          this.closeDialog()
        }
      },
      deep: true
    }
  },
  mounted() {
  },
  computed: {
    isOutOfRange() {
      const itemsDays = this.copyExercisesData.items.map(el => el.day)
      const minDay = Math.min(...itemsDays)
      const maxDay = Math.max(...itemsDays)
      const daysDuration = maxDay - minDay + 1
      const start = parseInt(this.copyExercisesData.start || 1, 10)
      const interval = parseInt(this.copyExercisesData.interval || 1, 10)
      const repetitions = parseInt(this.copyExercisesData.repetitions || 1, 10)

      const outOfRange = repetitions + (repetitions - 1) * (interval - 1) + start - 1 + daysDuration - 1

      return outOfRange > SEQUENCE_DAYS
    },
  },
  methods: {
    clearForm() {
      this.copyExercisesData = {...emptyForm}
      this.startValue = emptyForm.start || 1
      this.repetitionsValue = emptyForm.repetitions || 1
      this.intervalValue = emptyForm.interval || 1
    },
    formIsValid () {
      if (this.copyExercisesData?.title?.trim()!='')
      this.formIsValidCheck = true
      else this.formIsValidCheck = false
    },
    closeDialog () {
      this.dialog = false
      this.$emit('close-exercise-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === "Escape" && key.isTrusted) this.closeDialog()
    },
    onInput ({ name, value }) {
      this.copyExercisesData[name] = value
      this.formIsValid()
    },
    onSubmit () {
      this.$emit('on-submit', { ...this.copyExercisesData })
      this.closeDialog()
    },
  }
}
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.sequence-copy-exercises {
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    margin-top: auto;
    max-height: calc(100% - #{2*$gutter}) !important;
    // looks little hacky
    > .v-card {
      width: 100%;
      height: 100%;
    }
  }
  &-form-body {
    height: 100%;
    display: flex;
    flex-direction: column;

    .v-toolbar {
      flex-grow: 0 !important;
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-size: 1.5715rem;
    font-weight: bold;
  }
  &__dots {
    span {
      width: 16px;
      height: 16px;
      display: inline-block;
      border-radius: 50%;
      background-color:$bh-white;
      margin:0 3px;
      transition-duration: 300ms;
      &.active {
        background-color:$bh-blue;
      }
    }
  }
  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-blue;
      padding-left: 1.5*$gutter;
      padding-right: 1.5*$gutter;
    }
    &-container {
      padding-left: 1.5*$gutter;
      padding-right: 1.5*$gutter;
      display: flex;
      flex-direction: column;
      overflow: auto;
      .v-data-table__wrapper {
        overflow: unset;
      }
      .bh-input-pill {
        height: 48px !important;
        margin-bottom:8px !important;
        width: auto;
        .v-input__slot {
          align-items: center;
          height: 48px;
          min-height: 0 !important;
          &::before,
          &::after {
            content: "";
            display: none;
          }
          .v-input__append-inner {
            align-self: center;
            margin-top: 0 !important;
          }
          .v-icon {
            color: $bh-blue;
          }
        }
      }
    }
    &-footer {
      padding: 1.5*$gutter;
    }
  }
  &-form {
    background-color: $bh-blue--4;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;

    &-body {
      ::v-deep .v-toolbar__content {
        padding-left: 1.5*$gutter;
        padding-right: 1.5*$gutter;
      }
    }
    &-col-left {
      padding-top: 0;
      padding-right: 0.25*$gutter;
    }
    &-col-right {
      padding-top: 0;
      padding-left: 0.25*$gutter
    }
  }
}
</style>
